import React from "react";
import { FieldRenderProps } from "react-final-form";
import { errorMessage } from "../common.css.js";
import MarkdownRenderer from "../../../MarkdownRenderer.js";
import {
    checkboxInput,
    checkboxInputWrapper,
    checkboxText,
} from "./CheckboxInput.css.js";

type Props = FieldRenderProps<any, HTMLElement>;
const CheckboxInput: React.FC<Props> = ({
    text,
    input,
    meta,
    ...rest
}: Props) => {
    return (
        <div className={checkboxInputWrapper}>
            <input
                type="checkbox"
                {...input}
                {...rest}
                className={checkboxInput}
            />
            <div>
                <MarkdownRenderer source={text} className={checkboxText} />
                {meta.error && meta.touched && (
                    <span className={errorMessage}>{meta.error}</span>
                )}
            </div>
        </div>
    );
};

export default CheckboxInput;
